import get from 'lodash/get';
import { ShareholderDetails } from '@/modules/entity/types/EntityItemResponse.ts';
import {
  OnboardingRoadItem,
  createShareholderStep,
} from '@/modules/entity/utils/stepper/roadsTypes.ts';

interface AddedShareholdersRecursiveProps {
  shareholders: ShareholderDetails[];
  entity_type_prefix: string;
  newRoadItems: OnboardingRoadItem[];
  navName: string;
}
export const addedShareholdersRecursive = ({
  shareholders,
  newRoadItems,
  entity_type_prefix,
  navName,
}: AddedShareholdersRecursiveProps) => {
  const subShareholders = shareholders
    .map((shareholder: ShareholderDetails, indexShareholder) => {
      const shares = get(shareholder, 'shareholders', [])?.map(
        (subShareholder: ShareholderDetails, indexSubShareholder) => ({
          shareholders: subShareholder,
          indexShareholder,
          indexSubShareholder,
          person_details_key: 'shareholders',
          navName:
            (navName?.endsWith('s') ? navName?.slice(0, -1) : navName) +
            ` #${indexShareholder + 1} Shareholders`,
        }),
      );
      const directors = get(shareholder, 'directors', [])?.map(
        (subShareholder: ShareholderDetails, indexSubShareholder) => ({
          shareholders: subShareholder,
          indexShareholder,
          indexSubShareholder,
          person_details_key: 'directors',
          navName:
            (navName?.endsWith('s') ? navName?.slice(0, -1) : navName) +
            ` #${indexShareholder + 1} Directors`,
        }),
      );
      return [...directors, ...shares];
    })
    .flat();
  subShareholders.forEach(item => {
    const step = createShareholderStep({
      navName: item.navName + ' details',
      entity_type_prefix: `${entity_type_prefix}.[${item.indexShareholder}]`,
      person_details_key: item.person_details_key,
    });

    const indexRoadItem = newRoadItems.findIndex(
      obj =>
        obj.entity_type_prefix === `${entity_type_prefix}.[${item.indexShareholder}]` &&
        obj.person_details_key === item.person_details_key,
    );

    const theSameShareholders = subShareholders
      .filter(
        obj =>
          obj.indexShareholder === item.indexShareholder &&
          obj.person_details_key === item.person_details_key,
      )
      .map(obj => obj.shareholders)
      .filter(obj => !obj.same_as_index);

    if (indexRoadItem < 0 && theSameShareholders.length > 0 && !item.shareholders.same_as_index) {
      newRoadItems.push(step);
      //recursive
      addedShareholdersRecursive({
        shareholders: theSameShareholders,
        newRoadItems,
        entity_type_prefix: `${entity_type_prefix}.[${item.indexShareholder}].${item.person_details_key}`,
        navName: item.navName,
      });
    }
  });
};
